import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import styles from "./allAssessments.module.css";

const fetchCompanyData = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const raw = JSON.stringify({ "useremail": "" });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };
  try {
    const response = await fetch("https://casaahaanahotels.com/search_company_data", requestOptions);
    return await response.json();
  } catch (error) {
    console.error("Error fetching company data:", error);
    return [];
  }
};

const fetchDepartmentData = async () => {
  try {
    const response = await axios.post("https://casaahaanahotels.com/get_master_assessment_type", {});
    return response.data;
  } catch (error) {
    console.error("Error fetching department data:", error);
    return [];
  }
};

const ReviewByDepartment = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [selectedDepartmentCode, setSelectedDepartmentCode] = useState("");
  const [searchUserEmail, setSearchUserEmail] = useState("");
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();

  // Load assessments with filters
  const loadAssessments = async (filters) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://casaahaanahotels.com/new_list_assessments",
        filters,
        { headers: { "Content-Type": "application/json" } }
      );
      const result = Array.isArray(response.data?.result)
        ? response.data.result
        : [];
      setAssessments(result);

      if (result.length === 0) {
        setError("No assessments have been created yet!");
      } else {
        setError("");
      }
    } catch (err) {
      console.error("Error fetching assessments:", err);
      setError("Failed to fetch assessments.");
    } finally {
      setLoading(false);
    }
  };

  // On mount, load all assessments (with empty filters)
  useEffect(() => {
    loadAssessments({
      useremail: "",
      companycode: "",
      departmentcode: ""
    });
  }, []);

  // Fetch company data
  useEffect(() => {
    let isMounted = true;
    const loadCompanies = async () => {
      const data = await fetchCompanyData();
      if (isMounted) {
        setCompanies(data);
      }
    };
    loadCompanies();
    return () => { isMounted = false; };
  }, []);

  // Fetch department data
  useEffect(() => {
    let isMounted = true;
    const loadDepartments = async () => {
      const data = await fetchDepartmentData();
      if (isMounted) {
        setDepartments(data);
      }
    };
    loadDepartments();
    return () => { isMounted = false; };
  }, []);

  // When assessments change, reset to first page
  useEffect(() => {
    setCurrentPage(1);
  }, [assessments.length]);

  // Handle search button click: call API with selected filters
  const handleSearch = () => {
    loadAssessments({
      useremail: searchUserEmail.trim(),
      companycode: selectedCompanyCode,
      departmentcode: selectedDepartmentCode
    });
  };

  // Pagination logic
  const totalPages = Math.ceil(assessments.length / itemsPerPage);
  const paginatedAssessments = assessments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Helper to generate pagination numbers with ellipsis
  const getPagination = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page === '...') return;
    setCurrentPage(page);
  };

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assessment List</h2>
      
      <div className={styles.filterContainer}>
        {/* Department dropdown */}
        <select 
          className={styles.departmentDropdown}
          value={selectedDepartmentCode}
          onChange={(e) => setSelectedDepartmentCode(e.target.value)}
        >
          <option value="">All Departments</option>
          {departments.map((dept) => (
            <option key={dept.assessment_type_id} value={dept.assessment_type_id}>
              {dept.AssessmentType}
            </option>
          ))}
        </select>
        
        {/* Search button */}
        <button onClick={handleSearch} className={styles.searchButton}>
          Search
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Email</th>
                <th>Company Name</th>
                <th>Star Score</th>
                <th>Completed Date</th>
                <th>Validity</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {paginatedAssessments.map((assessment, idx) => {
                if (assessment?.driverid && assessment?.score != null) {
                  const firstName = assessment.driver_details?.FirstName || "N/A";
                  const lastName = assessment.driver_details?.LastName || "N/A";
                  const driverName = `${firstName} ${lastName}`;
                  const driverEmail = assessment.driver_details?.DriverEmail || "N/A";
                  const companyName = assessment.company_details?.companyname || "N/A";
                  const starScore = assessment.score;
                  const completedDate = new Date(assessment.timestamp).toLocaleDateString("en-US");
                  const validityDate = new Date(assessment.validity).toLocaleDateString("en-US");
                  const assessmentId = assessment.assessementid;
                  return (
                    <tr key={idx}>
                       <td title={driverName}>{driverName}</td>
                      <td title={driverEmail}>{driverEmail}</td>
                      <td title={companyName}>{companyName}</td>
                      <td>
                        <img
                          src={`https://starbehaviors.com/uploadimage/${starScore}.png`}
                          alt={`Score: ${starScore}`}
                          className={styles.scoreImage}
                        />
                      </td>
                      <td>{completedDate}</td>
                      <td>{validityDate}</td>
                      <td>
                        <button
                          className={styles.viewButton}
                          onClick={() => navigate(`/admin/search-assessments/${assessmentId}`)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className={styles.pagination} style={{ marginTop: '16px', display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
              <button onClick={handlePrev} disabled={currentPage === 1} className={styles.pageButton}>Prev</button>
              {getPagination().map((page, idx) => (
                <button
                  key={idx}
                  onClick={() => handlePageClick(page)}
                  disabled={page === '...'}
                  className={
                    page === currentPage
                      ? styles.activePageButton
                      : styles.pageButton
                  }
                  style={{ minWidth: 32 }}
                >
                  {page}
                </button>
              ))}
              <button onClick={handleNext} disabled={currentPage === totalPages} className={styles.pageButton}>Next</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewByDepartment;
